import { Controller, useForm } from 'react-hook-form';
import { useNavigate } from 'react-router';
import { DatePickerInput, Flex, Input, SaveText } from '#atoms';
import useCreateAwardMutation from '#hooks/queries/onboard/useCreateAwardMutation';
import { useToast } from '#providers/ToastProvider';
import { PrevHeaderBarWithTitleTemplate } from '#templates';
import * as S from './styles';

type Inputs = {
  gotAt: Date;
  name: string;
  institution: string;
};

export function OnBoardCreateAward() {
  const navigate = useNavigate();
  const { showToast } = useToast();
  const { mutateAsync: createLicense, isLoading } = useCreateAwardMutation();
  const {
    control,
    handleSubmit,
    // formState: { errors },
    watch
  } = useForm<Inputs>({
    mode: 'onSubmit'
  });

  const watchAllFields = watch(['name', 'institution', 'gotAt']);

  const onSubmit = async (data: Inputs) => {
    try {
      await createLicense(data);
      navigate(-1);
    } catch (err: any) {
      showToast({
        type: 'fail',
        message: '수상 내역 등록에 실패했습니다.'
      });
    }
  };

  return (
    <PrevHeaderBarWithTitleTemplate
      title="수상"
      hasBorder={false}
      ContainerStyle={{ position: 'relative' }}
      defaultBackground
      rightContents={
        <SaveText
          disabled={watchAllFields.some(field => !field) || isLoading}
          text="저장"
          onClick={handleSubmit(onSubmit)}
        />
      }
    >
      <S.Wrapper>
        <Flex direction="column" gap={32}>
          <Controller
            control={control}
            name="name"
            render={({ field }) => (
              <Input
                labelText="수상명"
                placeholder="수상명을 입력해 주세요"
                type="text"
                required
                {...field}
              />
            )}
          />
          <Controller
            control={control}
            name="institution"
            render={({ field }) => (
              <Input
                labelText="기관명"
                placeholder="대회 주최 기관 등을 입력해 주세요"
                type="text"
                required
                {...field}
              />
            )}
          />
          <Flex direction="column" gap={16}>
            <Controller
              control={control}
              name="gotAt"
              render={({ field }) => (
                <DatePickerInput
                  label="수상 연월"
                  required
                  fullWidth
                  title="수상 연월 선택"
                  placeholder={
                    field.value ? undefined : '수상 연월을 입력해 주세요'
                  }
                  date={field.value}
                  onChange={field.onChange}
                  onlyYearMonth
                />
              )}
            />
          </Flex>
        </Flex>
      </S.Wrapper>
    </PrevHeaderBarWithTitleTemplate>
  );
}
